function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("rect", {
  width: 18,
  height: 10,
  rx: 4,
  fill: "#fff"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M5.469 4.793h2.265v2.96c-.367.12-.713.204-1.039.25-.323.05-.653.075-.992.075-.862 0-1.52-.252-1.976-.758-.454-.508-.68-1.235-.68-2.183 0-.922.263-1.64.789-2.157.529-.515 1.26-.773 2.195-.773.586 0 1.151.117 1.696.352l-.403.968a2.874 2.874 0 00-1.3-.312c-.524 0-.943.176-1.258.527-.315.352-.473.824-.473 1.418 0 .62.126 1.094.379 1.422.255.326.625.488 1.11.488.252 0 .508-.026.769-.078V5.801H5.469V4.793zM9.098 8V2.29h1.21V8h-1.21zm3.84 0h-1.192V2.29h3.274v.991h-2.082v1.473h1.937v.988h-1.938V8z",
  fill: "#A0AFBE"
});
function SvgGifWhiteBg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 10,
    fill: "none"
  }, props), _ref, _ref2);
}
export default SvgGifWhiteBg;